export const getAppVersion = (): string => process.env.NX_PUBLIC_APP_VERSION || 'Local build';
